import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Input,
  Card,
  CardBody,
  CardTitle,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import IntlMessages from '../../../../../../helpers/IntlMessages';

import { faLink, faEdit, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import { putAPI_Update_Response } from '../../../../../../constants/APIs';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';

function Link({
  reloadBotResponse,
  code,
  caption,
  link,
  setIsAddLinkToFalse,
  isAdd,
  messages,
  /** Globle property id from redux */
  propertyId,
  SaveRecommenderQuestionCode,
  locale,
}) {
  const [isEditing, setIsEditing] = useState(false);
  const [linkInput, setlinkInput] = useState(link || '');
  const [captionInput, setCaptionInput] = useState(caption || '');
  const [isdeleteAllVisible, setIsdeleteAllVisible] = useState(false);
  const [postData, setPostData] = useState({
    GroupId: getGroupID(),
    Code: code,
    Language: `${locale === 'en' ? 'en-US' : locale}`,
    Channel: 'WebsiteDirectLine',
    PropertyId: propertyId,
    Default: null,
    Overrides: {},
  });

  const handleCaptionChange = (e) => {
    setCaptionInput(e.target.value);
  };
  const toggleAll = () => {
    setIsdeleteAllVisible(!isdeleteAllVisible);
  };
  const handleLinkChange = (e) => {
    setlinkInput(e.target.value);
  };

  // Link
  const handleSave = async () => {
    try {
      return await AxiosAPI({
        method: 'put',
        url: putAPI_Update_Response,
        data: postData,
      })
        .then(() => {
          setIsEditing(false);
          if (setIsAddLinkToFalse) {
            setIsAddLinkToFalse();
          }
        })
        .finally(
          setTimeout(() => {
            if (SaveRecommenderQuestionCode !== undefined) {
              SaveRecommenderQuestionCode();
            } else {
              reloadBotResponse();
            }
          }, 1000)
        );
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    setPostData((pre) => {
      return {
        ...pre,
        Default: {
          Messages: messages,
          Url: linkInput,
          Caption: captionInput,
        },
      };
    });
    //console.log('Link Post Data', postData);
  }, [linkInput, captionInput]);

  const handleDelete = () => {
    let data = postData;
    const arr = [...postData.Default.Messages];
    data.Default = arr;
    try {
      return AxiosAPI({
        method: 'put',
        url: `${putAPI_Update_Response}`,
        data: data,
      }).then(
        setTimeout(() => {
          if (SaveRecommenderQuestionCode !== undefined) {
            SaveRecommenderQuestionCode();
          } else {
            reloadBotResponse();
          }
        }, 1000)
      );
    } catch (error) {
      console.error(error);
    }
  };

  const handleEdit = () => {
    setIsEditing(true);
  };

  const handleCancel = () => {
    setIsEditing(false);
    if (setIsAddLinkToFalse) {
      setIsAddLinkToFalse();
    }
  };

  const Editing = () => {
    return (
      <Fragment>
        <CardTitle>
          <Row>
            <Colxx xxs="6">
              <div>
                <FontAwesomeIcon icon={faLink} />
                <span> </span>
                <IntlMessages id="property.link" />
              </div>
            </Colxx>
            <Colxx xxs="6">
              <div className="float-right">
                <Button
                  color="secondary"
                  className="add-button"
                  size="xs"
                  onClick={handleSave}
                >
                  Save
                </Button>
                <b> </b>
                <Button
                  color="light"
                  className="add-button"
                  size="xs"
                  onClick={handleCancel}
                >
                  Cancel
                </Button>
              </div>
            </Colxx>
          </Row>
        </CardTitle>
        <Row>
          <Colxx xxs="12" style={{ marginTop: '10px' }}>
            <span>Caption</span>
          </Colxx>
          <Colxx xxs="12">
            <Input
              type="text"
              defaultValue={captionInput}
              onChange={handleCaptionChange}
            />
          </Colxx>
          <Colxx xxs="12" style={{ marginTop: '10px' }}>
            <span>Link</span>
          </Colxx>
          <Colxx xxs="12">
            <Input
              type="text"
              defaultValue={linkInput}
              onChange={handleLinkChange}
            />
          </Colxx>
        </Row>
      </Fragment>
    );
  };

  const Showing = () => {
    return (
      <Fragment>
        <CardTitle>
          <Row>
            <Colxx xxs="8">
              <FontAwesomeIcon icon={faLink} />
              <span> </span>
              <IntlMessages id="property.link" />
            </Colxx>
            <Colxx xxs="4">
              <div className="float-right">
                <FontAwesomeIcon
                  icon={faEdit}
                  color="#90caf9"
                  cursor="pointer"
                  onClick={handleEdit}
                />
                <b> | </b>
                <FontAwesomeIcon
                  icon={faTrashAlt}
                  color="#e57373"
                  cursor="pointer"
                  onClick={toggleAll}
                />
              </div>
            </Colxx>
          </Row>
        </CardTitle>
        <Row>
          <Colxx xxs="12" lg="2">
            <b>Caption:</b>
          </Colxx>
          <Colxx xxs="12" lg="3">
            <span>{captionInput}</span>
          </Colxx>
          <Colxx xxs="12" lg="2">
            <b>Link:</b>
          </Colxx>
          <Colxx xxs="12" lg="5">
            <span>{linkInput}</span>
          </Colxx>
        </Row>
        <Modal isOpen={isdeleteAllVisible} toggle={toggleAll}>
          <ModalHeader toggle={toggleAll}>
            <span role="img" aria-label="warning">
              ⚠️
            </span>
            Link will be deleted!
          </ModalHeader>
          <ModalBody>
            <Button color="danger" onClick={() => handleDelete()} size="xs">
              Delete
            </Button>
            <Button
              className="ml-2"
              color="dark"
              outline
              size="xs"
              onClick={toggleAll}
            >
              Cancel
            </Button>
          </ModalBody>
        </Modal>
      </Fragment>
    );
  };

  return (
    <Card>
      <CardBody>{isEditing || isAdd ? Editing() : Showing()}</CardBody>
    </Card>
  );
}

Link.propTypes = {
  code: PropTypes.string.isRequired,
  link: PropTypes.string,
  caption: PropTypes.string,
  isAdd: PropTypes.bool,
  setIsAddLinkToFalse: PropTypes.func,
};

const mapStateToProps = ({ settings }) => {
  const { propertyId, locale } = settings;
  return {
    propertyId,
    locale,
  };
};

export default injectIntl(connect(mapStateToProps)(Link));
